import { jsx as _jsx } from "react/jsx-runtime";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import cx from "classnames";
/**
 * The Separator component creates a divider line used to visually separate
 * content.
 *
 * @component
 *
 * @param {SeparatorPrimitive.SeparatorProps} props The props for the Separator component.
 * @param {"horizontal" | "vertical"} props.orientation The orientation of the separator line. Available options are "horizontal" and "vertical".
 * @param {string} [props.className] The CSS class to apply to the component.
 *
 * @returns {JSX.Element} The rendered Separator component.
 */
const Separator = ({ className, orientation, ...separatorProps }) => {
    return (_jsx(SeparatorPrimitive.Root, { ...separatorProps, className: cx({
            "w-[1px]": orientation === "vertical",
            "h-[1px]": orientation === "horizontal",
        }, className) }));
};
export default Separator;
//# sourceMappingURL=Separator.js.map